import {BaseComponent} from '../../../abstract/base.component';
import {ErrorConstants} from '../../../shared/constants/error-constants';
import { Directive } from "@angular/core";

@Directive()
export abstract class PaypalTransactionDetailsAction extends BaseComponent {
  protected _apiGetUrl: string;
  protected _apiRefundUrl: string;
  protected _getTransactionPdf: string;

  protected getPaymentDetails() {
    this.loadFlag = true;
    this.dataManager.getRequest(this._apiGetUrl, 0)
      .subscribe(
        (response) => {
          this.passPaymentDetails(response);
          if (response.data.length === 0) {
            this.errorMsg = ErrorConstants.paymentDetailErrorMsg[0];
          } else {
            this.errorMsg = null;
          }
        },
        error => {
          this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.paymentDetailErrorMsg);
          this.passApiError(error); }
      );
  }

  protected refundOrder() {
    this.loadFlag = true;
    this.dataManager.postRequest(this._apiRefundUrl, {}, 0)
      .subscribe(
        (response) => {
          this.passPaymentDetails(response);
          if (response.data.length === 0) {
            this.errorMsg = ErrorConstants.paymentDetailErrorMsg[0];
          } else {
            this.errorMsg = null;
          }
        }, error => {
          this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.paymentDetailErrorMsg);
          this.passApiError(error);
        }
      );
  }

  protected getTransactionPDF() {
    this.loadFlag = true;
    this.dataManager.getRequestPdf(this._getTransactionPdf, 0).subscribe(
      (res) => {
        this.loadFlag = false;
        this.passTransactionPdfResponse((new Blob([res], {type: 'application/pdf'})));
      },
      (err) => {
        this.loadFlag = false;
        this.passTransactionPdfError(err);
      },
      () => this.passTransactionPdfComplete()
    );
  }

  protected abstract passTransactionPdfResponse(res);
  protected abstract passTransactionPdfError(error);
  protected abstract passTransactionPdfComplete();
  protected abstract passPaymentDetails(paymentDetails);
  protected abstract passApiError(error);
}
